import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

import { msalInstance } from './auth';
import { API_ERROR_MESSAGES } from './constants';
import { BACKEND_API, APPLICATION_ID } from '../global-config';

const axiosInstance = axios.create({
  baseURL: `${BACKEND_API.baseUrl}${BACKEND_API.prefix}`,
});

axiosInstance.interceptors.request.use(async (config) => {
  try {
    // Do not add headers for s3 buckets calls
    if (config.url?.includes('s3.amazonaws.com')) {
      return config;
    }
    const sessionId = localStorage.getItem('sessionId');
    const idToken = localStorage.getItem('idToken');

    config.headers.Authorization = `Bearer ${idToken}`;
    config.headers.correlationId = uuidv4();
    config.headers.application = APPLICATION_ID;

    if (sessionId) {
      config.headers['x-session-id'] = sessionId;
    }

    return config;
  } catch (error) {
    console.error(error);
  }

  return config;
});

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => {
    if (axios.isCancel(error)) {
      throw new Error(API_ERROR_MESSAGES.REQUEST_CANCELED);
    }

    const errorResponse = error.response;

    // Check if the error has a response
    if (errorResponse) {
      // Handle 401 Unauthorized errors when idToken is expired earlier than expected
      if (errorResponse.status === 401) {
        msalInstance.loginRedirect();
        return;
      }

      // Handle errors from Gateway and backend service
      if (errorResponse.status === 503) {
        throw new Error(API_ERROR_MESSAGES.SERVICE_UNAVAILABLE);
      }
    }

    throw new Error(errorResponse.data.error?.message || API_ERROR_MESSAGES.UNKNOWN_ERROR);
  }
);

export default axiosInstance;
